'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Takes an array of clinics then return an array of branches, doctors and rooms
 * @param {array} clinics array of clinics object
 */
var flattenClinics = function flattenClinics(clinics) {
  var entities = [];
  var branches = [];
  var rooms = [];
  var hasMultipleClinics = clinics.length > 1;
  var entitiesNames = new Map();
  var branchesNames = new Map();
  var roomsNames = new Map();
  var doctorsNames = new Map();
  var branchesMap = new Map();
  var doctors = [];
  var doctorsHaveSpecialityAttr = true;

  clinics.forEach(function (clinic) {
    entitiesNames.set(clinic.EntityName, clinic.EntityKey);
    entities.push({
      entityName: clinic.EntityName,
      entityKey: clinic.EntityKey
    });

    clinic.Branches.forEach(function (branch) {
      branches.push(_extends({}, branch, { EntityName: clinic.EntityName }));
      branchesNames.set(branch.BranchKey, branch.BranchName);
      branchesMap.set(branch.BranchKey, _extends({}, branch, { EntityName: clinic.EntityName }));

      branch.Rooms.forEach(function (room) {
        rooms.push(room);
        roomsNames.set(room.RoomKey, room.RoomName);

        room.Doctors.forEach(function (doctor) {
          if (!Object.prototype.hasOwnProperty.call(doctor, 'MainSpecialty')) doctorsHaveSpecialityAttr = false;
          doctors.push(_extends({}, doctor, { RoomKey: room.RoomKey }));
          doctorsNames.set(doctor.AccountKey, doctor.DoctorName);
        });
      });
    });
  });

  if (doctorsHaveSpecialityAttr) {
    var sortBySpeciality = function sortBySpeciality(a, b) {
      var x = a.MainSpecialty.SpecialityNameEnglish.toLowerCase();
      var y = b.MainSpecialty.SpecialityNameEnglish.toLowerCase();
      if (x < y) {
        return -1;
      } else if (x > y) {
        return 1;
      }
      return 0;
    };
    doctors = doctors.sort(sortBySpeciality);
  }

  return {
    entities: entities,
    branches: branches,
    rooms: rooms,
    doctors: doctors,
    hasMultipleClinics: hasMultipleClinics,
    entitiesNames: entitiesNames,
    branchesNames: branchesNames,
    roomsNames: roomsNames,
    doctorsNames: doctorsNames,
    branchesMap: branchesMap
  };
};

var getRoomsInBranches = function getRoomsInBranches(branches, branchesKeys) {
  return branches.filter(function (branch) {
    return branchesKeys.includes(branch.BranchKey);
  }).map(function (branch) {
    return branch.Rooms;
  }).reduce(function (prevRooms, nextRooms) {
    return prevRooms.concat(nextRooms);
  }, []);
};

var getDoctorsInRooms = function getDoctorsInRooms(rooms, roomsKeys, doctorsStatus) {
  var doctors = [];
  var doctorsKeys = [];

  rooms.forEach(function (room) {
    if (roomsKeys.includes(room.RoomKey)) {
      room.Doctors.forEach(function (doctor) {
        if (doctorsStatus === 6) {
          // Select All doctors
          if (!doctorsKeys.includes(doctor.AccountKey)) {
            doctorsKeys.push(doctor.AccountKey);
            doctors.push(doctor);
          }
        } else if (doctor.StatusId === doctorsStatus) {
          if (!doctorsKeys.includes(doctor.AccountKey)) {
            doctorsKeys.push(doctor.AccountKey);
            doctors.push(doctor);
          }
        }
      });
    }
  });

  return doctors;
};

var getDoctorsInfo = function getDoctorsInfo(rooms) {
  var res = [];

  rooms.forEach(function (room) {
    room.Doctors.forEach(function (doctor) {
      res.push({
        RoomKey: room.RoomKey,
        AccountKey: doctor.AccountKey,
        DoctorName: doctor.DoctorName
      });
    });
  });

  return res;
};

var getDoctorsNames = function getDoctorsNames(doctors) {
  var res = {};
  doctors.forEach(function (doctor) {
    res[doctor.AccountKey] = doctor.DoctorName;
  });
  return res;
};

var getRoomNames = function getRoomNames(rooms) {
  var res = {};
  rooms.forEach(function (room) {
    res[room.RoomKey] = room.RoomName;
  });
  return res;
};

var getBranchesNames = function getBranchesNames(branches) {
  var res = {};
  branches.forEach(function (branch) {
    branch.Rooms.forEach(function (room) {
      res[room.RoomKey] = branch.BranchName;
    });
  });
  return res;
};

exports.default = {
  flattenClinics: flattenClinics,
  getRoomsInBranches: getRoomsInBranches,
  getDoctorsInRooms: getDoctorsInRooms,
  getDoctorsInfo: getDoctorsInfo,
  getDoctorsNames: getDoctorsNames,
  getRoomNames: getRoomNames,
  getBranchesNames: getBranchesNames
};
module.exports = exports['default'];